export default "__VITE_ASSET__BnvRX0oB__"